import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from '~/api/api.js';
import grantchart from '~/components/grantchartQU.vue';

var miniToastr = void 0;
if (process.browser) {
  miniToastr = require('mini-toastr');
}
export default {
  middleware: ['auth'],
  mounted: function mounted() {
    miniToastr.init();
  },

  notifications: {
    showLoginError: {
      title: '',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          query = _ref.query;
      var userData, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              userData = store.state.authUser;
              _context.next = 3;
              return API.setToken(userData.tokenID);

            case 3:
              _context.next = 5;
              return API.GetDataFromRevise(query.quNo, query.revise);

            case 5:
              result = _context.sent;
              return _context.abrupt('return', {
                quNo: query.quNo,
                userData: userData,
                quData: result.data.datas,
                revise: query.revise,
                projectID: query.projectID
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {},

  components: {
    grantchart: grantchart
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/quotation/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/quotation/_id.vue
// module chunks = 43